(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["course-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function loadAll() {
      try {
        const d = JSON.parse(localStorage.getItem('courseProgress'));
        if (d && d.courses) return d;
      } catch (e) {}
      return { courses: {} };
    }

    function update() {
      const data = loadAll();
      document.querySelectorAll('.course-catalog__card').forEach((card) => {
        const id = card.getAttribute('data-cc-course-id');
        const total = parseInt(card.getAttribute('data-cc-total'), 10) || 0;
        const course = data.courses[id];
        const progressEl = card.querySelector('[data-cc-progress]');
        const ctaEl = card.querySelector('[data-cc-cta]');
        let done = 0;
        if (course && course.chapters) {
          done = Object.keys(course.chapters).filter((k) => course.chapters[k].done).length;
        }
        const started = !!(course && course.lastChapterId);
        if (total > 0 && done >= total) {
          if (progressEl) progressEl.textContent = 'Finished — all ' + total + ' chapters done';
          if (ctaEl) ctaEl.textContent = 'Watch again';
        } else if (started || done > 0) {
          if (progressEl) progressEl.textContent = done + ' of ' + total + ' chapters done';
          if (ctaEl) ctaEl.textContent = 'Continue';
        } else {
          if (progressEl) progressEl.textContent = 'Not started yet';
          if (ctaEl) ctaEl.textContent = 'Start course';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', update);
    } else {
      update();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["course-player"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STORAGE_KEY = 'courseProgress';
    const VERSION = 1;
    const DONE_RATIO = 0.9;

    function loadAll() {
      try {
        const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY));
        if (parsed && parsed.courses) return parsed;
      } catch (e) {}
      return { v: VERSION, courses: {} };
    }

    function saveAll(data) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {}
    }

    function getCourse(data, courseId) {
      return data.courses[courseId] || { lastChapterId: null, completedAt: null, chapters: {} };
    }

    function updateChapter(courseId, chapterId, patch) {
      const data = loadAll();
      const course = data.courses[courseId] || (data.courses[courseId] = { lastChapterId: null, completedAt: null, chapters: {} });
      const chapter = course.chapters[chapterId] || (course.chapters[chapterId] = { done: false, pos: 0, at: null });
      Object.assign(chapter, patch);
      chapter.at = new Date().toISOString();
      course.lastChapterId = chapterId;
      data.v = VERSION;
      saveAll(data);
    }

    function throttle(fn, delay) {
      let last = 0;
      let timer = null;
      return function () {
        const args = arguments;
        const now = Date.now();
        const remaining = delay - (now - last);
        if (remaining <= 0) {
          last = now;
          fn.apply(this, args);
        } else if (!timer) {
          timer = setTimeout(() => {
            last = Date.now();
            timer = null;
            fn.apply(this, args);
          }, remaining);
        }
      };
    }

    function initPlayer(layout) {
      const courseId = layout.dataset.courseId;
      if (!courseId) return;
      const video = layout.querySelector('#course-player-video');
      const processingEl = layout.querySelector('.course-player__processing');
      const heading = layout.querySelector('#course-player-heading');
      const buttons = Array.prototype.slice.call(layout.querySelectorAll('.course-player__chapter'));
      if (!buttons.length) return;
      const prevBtn = layout.querySelector('.course-player__prev');
      const nextBtn = layout.querySelector('.course-player__next');

      let currentChapterId = null;
      let currentIndex = 0;

      function paintCheckmarks() {
        const course = getCourse(loadAll(), courseId);
        buttons.forEach((btn) => {
          const done = !!(course.chapters[btn.dataset.cpChapterId] || {}).done;
          btn.classList.toggle('is-done', done);
          btn.setAttribute('aria-pressed', done ? 'true' : 'false');
        });
      }

      function markDoneUI(chapterId) {
        const btn = buttons.find((b) => b.dataset.cpChapterId === chapterId);
        if (btn) {
          btn.classList.add('is-done');
          btn.setAttribute('aria-pressed', 'true');
        }
      }

      function setCaptionTrack(url) {
        if (!video) return;
        video.querySelectorAll('track').forEach((t) => t.remove());
        if (url) {
          const track = document.createElement('track');
          track.kind = 'captions';
          track.src = url;
          track.srclang = 'en';
          track.label = 'English';
          track.default = true;
          video.appendChild(track);
        }
      }

      function applyResume(chapterId) {
        if (!video) return;
        const prog = getCourse(loadAll(), courseId).chapters[chapterId];
        if (!(prog && prog.pos > 0 && !prog.done)) return;
        const seek = () => {
          // Only resume to a real position that isn't near the end. A stale
          // position past a since-shortened video would otherwise land on the
          // final frame and falsely mark the chapter complete.
          const d = video.duration || 0;
          if (d && prog.pos < d * DONE_RATIO) {
            try { video.currentTime = prog.pos; } catch (e) {}
          }
        };
        if (video.readyState >= 1) seek();
        else video.addEventListener('loadedmetadata', seek, { once: true });
      }

      function selectChapter(btn, opts) {
        opts = opts || {};
        const src = btn.dataset.cpSrc;
        const titleEl = btn.querySelector('.course-player__chapter-title');
        const title = titleEl ? titleEl.textContent : '';
        currentIndex = buttons.indexOf(btn);
        buttons.forEach((b) => {
          b.classList.remove('is-active');
          b.removeAttribute('aria-current');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'true');
        if (prevBtn) prevBtn.disabled = currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= buttons.length - 1;
        if (opts.scroll) btn.scrollIntoView({ block: 'nearest' });
        if (heading) heading.textContent = title;

        if (!src) {
          // Video isn't ready (still processing / failed). Show a notice, keep
          // the previous video, and don't attribute progress saves to this chapter.
          currentChapterId = null;
          if (video) { video.hidden = true; video.removeAttribute('src'); video.load(); }
          if (processingEl) processingEl.hidden = false;
          return;
        }

        currentChapterId = btn.dataset.cpChapterId;
        if (processingEl) processingEl.hidden = true;
        if (video) {
          video.hidden = false;
          video.setAttribute('aria-label', title);
          video.src = src;
          setCaptionTrack(btn.dataset.cpCaptions);
          video.load();
          applyResume(currentChapterId);
          if (opts.autoplay) video.play().catch(() => {});
        }
      }

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => selectChapter(btn, { autoplay: true, scroll: true }));
      });
      if (prevBtn) prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) selectChapter(buttons[currentIndex - 1], { autoplay: true, scroll: true });
      });
      if (nextBtn) nextBtn.addEventListener('click', () => {
        if (currentIndex < buttons.length - 1) selectChapter(buttons[currentIndex + 1], { autoplay: true, scroll: true });
      });

      function saveProgress() {
        if (!currentChapterId || !video) return;
        const pos = Math.floor(video.currentTime || 0);
        const duration = video.duration || 0;
        const done = duration > 0 && pos >= duration * DONE_RATIO;
        updateChapter(courseId, currentChapterId, { pos: pos, done: done });
        if (done) markDoneUI(currentChapterId);
      }

      if (video) {
        // Frequent backstop while playing (throttled so we don't thrash localStorage).
        video.addEventListener('timeupdate', throttle(saveProgress, 5000));
        // Exact-position saves: the moment they pause, background the tab, or leave.
        video.addEventListener('pause', saveProgress);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'hidden') saveProgress();
        });
        window.addEventListener('pagehide', saveProgress);

        video.addEventListener('ended', () => {
          if (!currentChapterId) return;
          updateChapter(courseId, currentChapterId, { done: true, pos: Math.floor(video.duration || 0) });
          markDoneUI(currentChapterId);
        });
      }

      paintCheckmarks();

      const lastChapterId = getCourse(loadAll(), courseId).lastChapterId;
      let initialBtn = buttons[0];
      if (lastChapterId) {
        const match = buttons.find((b) => b.dataset.cpChapterId === lastChapterId);
        if (match) initialBtn = match;
      }
      selectChapter(initialBtn, { autoplay: false });
    }

    function init() {
      document.querySelectorAll('.course-player__layout').forEach(initPlayer);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
